import { Api } from "./api"

export class AdminPrivilegeApi extends Api {
  constructor() {
    super('admin_privileges', ['adminPrivileges'])
  }
}
